import { clsx } from 'clsx'
import { type FC } from 'react'

import { Modal } from 'base-ui'

import {
  DrawerTransition,
  UnstyledCssTransition,
} from '../../../../../../drawer-transition'

import { StoryblokCategoryNavigationContent } from './StoryblokCategoryNavigationContent'
import { useCategoriesNavigationContext } from './StoryblokCategoryNavigationProvider'

import style from './StoryblokCategoryNavigationSlider.module.css'

export const StoryblokCategoryNavigationSlider: FC = () => {
  const {
    animationDirection,
    currentCategoryData,
    handleClose,
    isOpen,
    previouseCategoryData: previousCategoryData,
  } = useCategoriesNavigationContext()

  return (
    <Modal
      className="flex flex-col items-start justify-start"
      closeAfterTransition
      data-qa-id="kategories-navigation"
      onClose={handleClose}
      open={isOpen}
    >
      <DrawerTransition
        className="flex h-dvh w-full flex-col overflow-y-auto rounded-l-none bg-light-primary-medium outline-none tablet:max-w-screen-tablet tablet:rounded-r-2xl"
        direction="left"
        in={isOpen}
      >
        <div className="relative w-full">
          {currentCategoryData ? (
            <UnstyledCssTransition
              className={clsx(
                style['storyblok-category-navigation-slider'],
                animationDirection === 'backward' &&
                  style['storyblok-category-navigation-slider_backward-enter'],
                animationDirection === 'forward' &&
                  style['storyblok-category-navigation-slider_forward-enter'],
              )}
              enterClassName={clsx(
                animationDirection === 'backward' &&
                  style[
                    'storyblok-category-navigation-slider_backward-enter-active'
                  ],
                animationDirection === 'forward' &&
                  style[
                    'storyblok-category-navigation-slider_forward-enter-active'
                  ],
              )}
              in={Boolean(currentCategoryData)}
              key={`slide-code-${currentCategoryData.akeneoCode}`}
            >
              <StoryblokCategoryNavigationContent
                categoryData={currentCategoryData}
              />
            </UnstyledCssTransition>
          ) : null}
          {previousCategoryData ? (
            <UnstyledCssTransition
              className={clsx(
                style['storyblok-category-navigation-slider'],
                animationDirection === 'backward' &&
                  style['storyblok-category-navigation-slider_backward-leave'],
                animationDirection === 'forward' &&
                  style['storyblok-category-navigation-slider_forward-leave'],
              )}
              enterClassName={clsx(
                animationDirection === 'backward' &&
                  style[
                    'storyblok-category-navigation-slider_backward-leave-active'
                  ],
                animationDirection === 'forward' &&
                  style[
                    'storyblok-category-navigation-slider_forward-leave-active'
                  ],
              )}
              in={Boolean(previousCategoryData) && Boolean(currentCategoryData)}
              key={`slide-code-${previousCategoryData.akeneoCode}`}
            >
              <StoryblokCategoryNavigationContent
                categoryData={previousCategoryData}
              />
            </UnstyledCssTransition>
          ) : null}
        </div>
      </DrawerTransition>
    </Modal>
  )
}
